import { observable, computed, makeObservable } from 'mobx';
import compact from 'lodash/compact';

import { FavoriteType } from 'chaika-frontend-types/frontend-cms';

import { ReferralFavoriteList } from './FavoriteLists/ReferralFavoriteList';
import { DrugFavoriteList } from './FavoriteLists/DrugFavoriteList';
import { EntryTypeFavoriteList } from '@store/AuthUser/models/FavoriteLists/EntryTypeList';
import { OfficeFavoriteList } from '@store/AuthUser/models/FavoriteLists/OfficeFavoriteList';

export class Favorites {
    @observable public referralFavoriteList = new ReferralFavoriteList();
    @observable public drugFavoriteList = new DrugFavoriteList();
    @observable public entryTypeFavoriteList = new EntryTypeFavoriteList();
    @observable public officeFavoriteList = new OfficeFavoriteList();

    constructor() {
        makeObservable(this);
    }

    @computed
    public get loadedTypes(): Set<FavoriteType> {
        return new Set(
            compact<FavoriteType>([
                this.referralFavoriteList.isDataSet && FavoriteType.Referral,
                this.drugFavoriteList.isDataSet && FavoriteType.Drug,
                this.entryTypeFavoriteList.isDataSet && FavoriteType.EntryType,
                this.officeFavoriteList.isDataSet && FavoriteType.Office,
            ]),
        );
    }

    @computed
    public get groupFavoriteDrugIds(): string[] {
        return this.drugFavoriteList.getFilteredValuesIds({ groupDrugs: true });
    }

    @computed
    public get ungroupFavoriteDrugIds(): string[] {
        return this.drugFavoriteList.getFilteredValuesIds({ groupDrugs: false });
    }
}
